import { render } from "./FormDeliveryPriceCalcItem.vue?vue&type=template&id=d5b3c10e"
import script from "./FormDeliveryPriceCalcItem.vue?vue&type=script&lang=js"
export * from "./FormDeliveryPriceCalcItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormDeliveryPriceCalcItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5b3c10e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5b3c10e', __exports__)) {
    console.log('reload')
    api.reload('d5b3c10e', __exports__)
  }
  
  module.hot.accept("./FormDeliveryPriceCalcItem.vue?vue&type=template&id=d5b3c10e", () => {
    console.log('re-render')
    api.rerender('d5b3c10e', render)
  })

}


export default __exports__